// @flow

export { InputUruguayanDocument } from './input-uruguayan-document';
export { InputUruguayanZipcode } from './input-uruguayan-zipcode';
